import React, { useContext, useEffect } from 'react';

import { classNames } from '../../utils/style';

import { Image } from '../Image';
import { ImageProps } from '../Image/types';
import CardContentContext from './CardContentContext';
import { useApplyLogoStyle } from './logic';

export type CardContentLogoProps = ImageProps & {
  classNameImg?: string;
};
export const CardContentLogo = ({
  classNameImg,
  className,
  ...props
}: CardContentLogoProps) => {
  const context = useContext(CardContentContext);
  const applyLogoStyle = useApplyLogoStyle();

  useEffect(() => context?.setHasLogo && context.setHasLogo(true), [context]);

  return (
    <div className={classNames(className, applyLogoStyle)}>
      <Image className={classNames('h-full', classNameImg)} {...props} />
    </div>
  );
};
